export interface EntityAdapter<TSource, TTarget> {
  adapt(source: TSource): TTarget;
  adaptMany?(sources: TSource[]): TTarget[];
}

export abstract class BaseEntityAdapter<TSource, TTarget> implements EntityAdapter<TSource, TTarget> {
  abstract adapt(source: TSource): TTarget;

  adaptMany(sources: TSource[]): TTarget[] {
    return sources.map(source => this.adapt(source));
  }
}